(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["truckerwear-roadtrip"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tw-roadtrip')) {
  customElements.define('tw-roadtrip', class extends HTMLElement {
    connectedCallback() {
      this.stopped = false;
      this.loadPosition();
      this.timer = setInterval(() => this.loadPosition(), 10000);
    }
    disconnectedCallback() { this.stopped = true; clearInterval(this.timer); }
    showState(text) {
      const container = document.createElement('div');
      container.className = 'tw-trip-placeholder';
      const icon = document.createElement('span'); icon.textContent = '🚛'; icon.setAttribute('aria-hidden', 'true');
      const message = document.createElement('p'); message.className = 'tw-trip-state'; message.setAttribute('role', 'status'); message.textContent = text;
      container.append(icon, message); this.querySelector('.tw-trip-map').replaceChildren(container);
      this.querySelector('.tw-trip-time').textContent = '';
      this.mapKey = '';
    }
    async loadPosition() {
      try {
        const response = await fetch(this.dataset.endpoint, {cache: 'no-store', credentials: 'omit', signal: AbortSignal.timeout(12000)});
        if (!response.ok) throw new Error('unavailable');
        const data = await response.json(); if (this.stopped) return;
        if (data.mode !== 'active' || !Number.isFinite(data.lat) || !Number.isFinite(data.lon)) {
          this.showState(data.mode === 'paused' ? this.dataset.paused : data.mode === 'active' ? this.dataset.waiting : this.dataset.ended); return;
        }
        const key = data.lat + ',' + data.lon;
        if (this.mapKey !== key) {
          const frame = document.createElement('iframe'); frame.title = this.dataset.mapTitle; frame.loading = 'lazy'; frame.referrerPolicy = 'no-referrer';
          frame.src = 'https://www.openstreetmap.org/export/embed.html?bbox=' + encodeURIComponent([data.lon-.08,data.lat-.035,data.lon+.08,data.lat+.035].join(',')) + '&layer=mapnik&marker=' + encodeURIComponent(key);
          this.querySelector('.tw-trip-map').replaceChildren(frame); this.mapKey = key;
        }
        const minutes = Math.max(0, Math.floor((Date.now()/1000-data.captured)/60));
        this.querySelector('.tw-trip-time').textContent = (data.label ? data.label + ' · ' : '') + this.dataset.updated.replace('[minutes]', minutes);
      } catch {
        if (!this.stopped) this.showState(this.dataset.error);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
